module.exports = __webpack_public_path__ + "img/icon_map_2.f80b1f37.png";